/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */
import { Document,
    Packer,
    Paragraph,
    TextRun,
    Table,
    TableRow,
    TableCell,
    AlignmentType,
    WidthType,
    BorderStyle, } from 'docx'
import { saveAs } from 'file-saver'
import { format } from '../utils/number'
import { getDateTime } from '../utils/date'

// DOCX receipt generator
export const generateDocxReceipt = (item = {}, result = 0, lend = 0) => {
    const currency = item?.currency === 'usd' ? 'USD' : 'СУМ'

    const doc = new Document({
        sections: [
            {
                properties: {
                    page: {
                        margin: {
                            top: 1134,
                            right: 1134,
                            bottom: 1134,
                            left: 1134,
                        },
                    },
                },
                children: [
                    // Header
                    new Paragraph({
                        children: [
                            new TextRun({
                                text: 'КОСМОС МОТОРС',
                                bold: true,
                                size: 32,
                            }),
                        ],
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 300 },
                    }),
                    new Paragraph({
                        children: [
                            new TextRun({
                                text: 'Тел: (93) 888-99-22 (Бекзод)',
                                size: 24,
                            }),
                        ],
                        alignment: AlignmentType.CENTER,
                    }),
                    new Paragraph({
                        children: [
                            new TextRun({
                                text: 'Тел: (97) 309-43-48 (Ислом)',
                                size: 24,
                            }),
                        ],
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 400 },
                    }),

                    // Receipt Title
                    new Paragraph({
                        children: [
                            new TextRun({
                                text: 'ЧЕК О ПОКУПКЕ',
                                bold: true,
                                size: 28,
                            }),
                        ],
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 300 },
                    }),

                    // Info Table
                    new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1 },
                            bottom: { style: BorderStyle.SINGLE, size: 1 },
                            left: { style: BorderStyle.SINGLE, size: 1 },
                            right: { style: BorderStyle.SINGLE, size: 1 },
                            insideHorizontal: { style: BorderStyle.SINGLE, size: 1 },
                            insideVertical: { style: BorderStyle.SINGLE, size: 1 },
                        },
                        rows: [
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: 'Кассир:', bold: true })],
                                            }),
                                        ],
                                        width: { size: 30, type: WidthType.PERCENTAGE },
                                    }),
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: 'Бекзод' })],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: 'Дата:', bold: true })],
                                            }),
                                        ],
                                    }),
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: getDateTime(new Date()) })],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: 'ID чека:', bold: true })],
                                            }),
                                        ],
                                    }),
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: item?.codeContent || 'N/A' })],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                            ...(item?.client?.name
                                ? [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                children: [
                                                    new Paragraph({
                                                        children: [new TextRun({ text: 'Клиент:', bold: true })],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                children: [
                                                    new Paragraph({
                                                        children: [new TextRun({ text: item.client.name })],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ]
                                : []),
                        ],
                    }),

                    new Paragraph({ text: '', spacing: { after: 400 } }),

                    // Products Title
                    new Paragraph({
                        children: [
                            new TextRun({
                                text: 'ТОВАРЫ',
                                bold: true,
                                size: 24,
                            }),
                        ],
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 300 },
                    }),

                    // Products Table
                    new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1 },
                            bottom: { style: BorderStyle.SINGLE, size: 1 },
                            left: { style: BorderStyle.SINGLE, size: 1 },
                            right: { style: BorderStyle.SINGLE, size: 1 },
                            insideHorizontal: { style: BorderStyle.SINGLE, size: 1 },
                            insideVertical: { style: BorderStyle.SINGLE, size: 1 },
                        },
                        rows: [
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: '№', bold: true })],
                                                alignment: AlignmentType.CENTER,
                                            }),
                                        ],
                                        width: { size: 10, type: WidthType.PERCENTAGE },
                                    }),
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: 'Наименование', bold: true })],
                                                alignment: AlignmentType.CENTER,
                                            }),
                                        ],
                                        width: { size: 40, type: WidthType.PERCENTAGE },
                                    }),
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: 'Кол-во', bold: true })],
                                                alignment: AlignmentType.CENTER,
                                            }),
                                        ],
                                        width: { size: 15, type: WidthType.PERCENTAGE },
                                    }),
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: 'Цена', bold: true })],
                                                alignment: AlignmentType.CENTER,
                                            }),
                                        ],
                                        width: { size: 17.5, type: WidthType.PERCENTAGE },
                                    }),
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: 'Сумма', bold: true })],
                                                alignment: AlignmentType.CENTER,
                                            }),
                                        ],
                                        width: { size: 17.5, type: WidthType.PERCENTAGE },
                                    }),
                                ],
                            }),
                            ...(Array.isArray(item?.orderProduct)
                                ? item.orderProduct.map(
                                    (prod, i) => new TableRow({
                                        children: [
                                            new TableCell({
                                                children: [
                                                    new Paragraph({
                                                        children: [new TextRun({ text: (i + 1).toString() })],
                                                        alignment: AlignmentType.CENTER,
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                text: prod?.product?.name || 'N/A',
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                text: Number(prod?.count || 0).toString(),
                                                            }),
                                                        ],
                                                        alignment: AlignmentType.CENTER,
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                text: `${format(prod?.price || 0)} ${currency}`,
                                                            }),
                                                        ],
                                                        alignment: AlignmentType.RIGHT,
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                text: `${format(
                                                                    Number(prod?.count || 0)
                                                                              * Number(prod?.price || 0),
                                                                )} ${currency}`,
                                                            }),
                                                        ],
                                                        alignment: AlignmentType.RIGHT,
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                )
                                : []),
                        ],
                    }),

                    new Paragraph({ text: '', spacing: { after: 400 } }),

                    // Total Table
                    new Table({
                        width: { size: 60, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.RIGHT,
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1 },
                            bottom: { style: BorderStyle.SINGLE, size: 1 },
                            left: { style: BorderStyle.SINGLE, size: 1 },
                            right: { style: BorderStyle.SINGLE, size: 1 },
                            insideHorizontal: { style: BorderStyle.SINGLE, size: 1 },
                            insideVertical: { style: BorderStyle.SINGLE, size: 1 },
                        },
                        rows: [
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [new TextRun({ text: 'К ОПЛАТЕ:', bold: true })],
                                            }),
                                        ],
                                        width: { size: 50, type: WidthType.PERCENTAGE },
                                    }),
                                    new TableCell({
                                        children: [
                                            new Paragraph({
                                                children: [
                                                    new TextRun({
                                                        text: `${format(result || 0)} ${currency}`,
                                                        bold: true,
                                                    }),
                                                ],
                                                alignment: AlignmentType.RIGHT,
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                            ...(lend && lend > 0
                                ? [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                children: [
                                                    new Paragraph({
                                                        children: [new TextRun({ text: 'Сумма долга:', bold: true })],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                children: [
                                                    new Paragraph({
                                                        children: [
                                                            new TextRun({
                                                                text: `${format(lend)} ${currency}`,
                                                                bold: true,
                                                                color: 'red',
                                                            }),
                                                        ],
                                                        alignment: AlignmentType.RIGHT,
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ]
                                : []),
                        ],
                    }),

                    new Paragraph({ text: '', spacing: { after: 600 } }),

                    // Footer
                    new Paragraph({
                        children: [
                            new TextRun({
                                text: 'Спасибо за покупку!',
                                bold: true,
                                size: 24,
                            }),
                        ],
                        alignment: AlignmentType.CENTER,
                    }),
                    new Paragraph({
                        children: [
                            new TextRun({
                                text: 'Приходите к нам еще!',
                                size: 20,
                            }),
                        ],
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 400 },
                    }),
                ],
            },
        ],
    })

    return doc
}

// Download DOCX file
export const downloadDocxReceipt = async (item, result, lend) => {
    try {
        const doc = generateDocxReceipt(item, result, lend)
        const blob = await Packer.toBlob(doc)
        const fileName = `receipt_${item?.codeContent || 'unknown'}_${new Date()
            .toISOString()
            .split('T')[0]}.docx`
        saveAs(blob, fileName)
    } catch (error) {
        console.error('Error generating DOCX:', error)
        alert('Ошибка при генерации DOCX файла')
    }
}
